/* eslint-disable */
import React from 'react';
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import Footer from 'components/Footer/Footer.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';
import styles from 'assets/jss/customStyle.jsx';
import NavigationBar from 'components/inc/NavigationBar.jsx';
import profilePageStyle from 'assets/jss/material-kit-pro-react/views/profilePageStyle.jsx';
import NewUser from 'components/CreateUser/CreateUser.jsx';
import connect from 'react-redux/es/connect/connect';
import { createNewUser } from '../../actions/createUser';
import { getUserData } from '../../utils/common';
import { Container } from '@material-ui/core';

var generator = require('generate-password');

class CreateUsers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userRole: null,
      email: '',
      newPassword: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      message: '',
      timezone: '',
      errors: {},
      isLoading: false,
      invite: false,
      disabled: {},
    };
  }

  validateEmail = (email) => {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  onValidation = () => {
    const {
      firstName,
      lastName,
      email,
      newPassword,
      confirmPassword,
      userRole,
    } = this.state;
    let errors = {};
    let formIsValid = true;

    if (!email) {
      formIsValid = false;
      errors['email'] = 'Email cannot be empty.';
    } else if (email.length > 50) {
      formIsValid = false;
      errors['email'] = 'The Email should be lower than 50 character.';
    } else if (!this.validateEmail(email)) {
      formIsValid = false;
      errors['email'] = 'Invalid Email.';
    }

    if (!firstName) {
      formIsValid = false;
      errors['firstName'] = 'First name cannot be empty.';
    } else if (firstName.length > 30) {
      formIsValid = false;
      errors['firstName'] = 'The First Name should be less than 30 characters.';
    }

    if (!lastName) {
      formIsValid = false;
      errors['lastName'] = 'Last name cannot be empty ';
    } else if (lastName.length > 30) {
      formIsValid = false;
      errors['lastName'] = 'The last name should be less than 30 characters.';
    }

    if (!userRole) {
      formIsValid = false;
      errors['userRole'] = 'The user role cannot be empty.';
    }

    if (!newPassword && !this.state.invite) {
      formIsValid = false;
      errors['password'] = 'Password cannot be empty password.';
    } else if (newPassword.length > 30) {
      formIsValid = false;
      errors['password'] = 'The Password should be lower than 30 character.';
    }

    if (!confirmPassword && !this.state.invite) {
      formIsValid = false;
      errors['confirmPassword'] = 'Confirm Password cannot be empty.';
    } else if (confirmPassword.length > 30) {
      formIsValid = false;
      errors['confirmPassword'] =
        'The confirm Password should be lower than 30 character.';
    } else if (newPassword !== confirmPassword) {
      formIsValid = false;
      errors['confirmPassword'] = 'Password needs to match..';
    }
    this.setState({ errors: errors });
    return formIsValid;
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onRoleChange = (event) => {
    this.setState({ userRole: event.target.value });
  };

  handleSubmit = async () => {
    const { email, newPassword, firstName, lastName, userRole } = this.state;
    let userData = {
      email: email,
      password: this.state.invite
        ? generator.generate({
            length: 10,
            numbers: true,
            uppercase: true,
            symbols: true,
            strict: true,
          }) + 'sS$'
        : newPassword,
      firstName: firstName,
      lastName: lastName,
      userRoles: [userRole],
    };

    try {
      if (this.onValidation()) {
        this.setState({
          isLoading: true,
        });
        const response = await this.props.createNewUser(
          userData,
          this.state.invite
        );

        if (response && response.success) {
          this.setState({
            isLoading: false,
          });
          this.props.history.replace(`/user-list`);
        } else {
          this.setState({
            message:
              response &&
              response.response &&
              response.response.data &&
              response.response.data.errorMessage,
            isLoading: false,
          });
        }
      }
    } catch (er) {
      this.setState({ message: er });
    }
  };

  onBack = () => {
    this.props.history.replace(`/user-list`);
  };

  render() {
    const { classes } = this.props;
    const userData = getUserData();

    return (
      <main>
        <NavigationBar />
        <Container maxWidth='lg' component='section'>
          <NewUser
            state={this.state}
            onChange={this.onChange}
            userData={userData}
            handleSubmit={this.handleSubmit}
            onRoleChange={this.onRoleChange}
            onBacke={this.onBack}
            disabled={this.state.disabled}
            onInviteChange={() => {
              this.setState({ invite: !this.state.invite }, () => {
                if (this.state.invite) {
                  this.setState({
                    disabled: {
                      newPassword: true,
                      confirmPassword: true,
                    },
                  });
                } else {
                  this.setState({
                    disabled: {},
                  });
                }
              });
            }}
          />
        </Container>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  createUserSavedData: state.createUsers.createUserSavedData,
});

const mapDispatchToProps = (dispatch) => ({
  createNewUser: (data, invite) => dispatch(createNewUser(data, invite)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(profilePageStyle)(CreateUsers));
